import { useState, useEffect } from 'react';
import {
    Card,
    CardGroup,
    Text
} from 'rsuite';

function News() {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch('/articles.json')
            .then(res => {
                if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
                return res.json();
            })
            .then(data => {
                setArticles(data);
                setLoading(false);
            })
            .catch(err => {
                setError(err.message);
                setLoading(false);
            });
    }, []);

    if (loading) return <Text>Loading...</Text>;
    if (error) return <Text>Error: {error}</Text>;

    return (
        <CardGroup columns={2} spacing={40}>
            {articles.map(article => (
                <Card key={article.id} height={'35vh'} width={'30vw'}>
                    <img src={article.image} height={'200vh'} alt={article.headline}/>
                    <Card.Header as='h6'>{article.headline}</Card.Header>
                    <Card.Body>{article.content}</Card.Body>
                </Card>
            ))}
        </CardGroup>
    );
}

export default News;